export default [
  {
    title: 'Inbox',
    icon: 'MailIcon',
    resource: 'Inbox',
    action: 'manage',
    route: 'komship-inbox',
  },
]
